module.exports = __webpack_public_path__ + "img/k4.1fbb7483.png";